import { render, staticRenderFns } from "./ReviewCardDemo.vue?vue&type=template&id=04f0c672&"
import script from "./ReviewCardDemo.vue?vue&type=script&lang=js&"
export * from "./ReviewCardDemo.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCardDemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports